import { render, staticRenderFns } from "./Rrhh.vue?vue&type=template&id=2a10dd6c&scoped=true&"
import script from "./Rrhh.vue?vue&type=script&lang=js&"
export * from "./Rrhh.vue?vue&type=script&lang=js&"
import style0 from "./Rrhh.vue?vue&type=style&index=0&id=2a10dd6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10dd6c",
  null
  
)

export default component.exports